import React from 'react'
const Circle = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="7.33333" stroke="black" strokeWidth="1.33333" />
      <circle cx="8.00004" cy="8.00065" r="4" stroke="black" strokeWidth="1.33333" />
      <path
        d="M11.1232 5.69547L10.2852 4.85742L8.34716 6.79542L8.34716 7.63347L9.18521 7.63347L11.1232 5.69547Z"
        fill="black"
      />
      <path
        d="M5.57243 4.85921L4.73438 5.69727L6.67237 7.63526L7.51042 7.63526L7.51042 6.79721L5.57243 4.85921Z"
        fill="black"
      />
      <path
        d="M5.57243 11.2502L4.73438 10.4121L6.67237 8.47411L7.51042 8.47411L7.51042 9.31217L5.57243 11.2502Z"
        fill="black"
      />
      <path
        d="M10.283 11.2502L11.1211 10.4121L9.1831 8.47411L8.34505 8.47411L8.34505 9.31216L10.283 11.2502Z"
        fill="black"
      />
    </svg>
  )
}

export default Circle
